// import React, { FC, useEffect, useState } from 'react';

// import AppBar from '@mui/material/AppBar';
// import { grey } from '@mui/material/colors';
// import { styled, useTheme } from '@mui/material/styles';
// import Toolbar from '@mui/material/Toolbar';
// import Typography from '@mui/material/Typography';
// import { ITest } from '@websential/cosmic-v20';
// import { IconButton,
//   Box, } from '@mui/material';
// import DehazeIcon from '@mui/icons-material/Dehaze';
// import "./EnhancedAppBarStyle.css"

// import { useDispatch, useSelector } from 'react-redux';
// // import { setDrawerCurrentState } from 'store/actions/drawerActions';

// import { useNavigate } from "react-router-dom";
// import { Menubar } from 'primereact/menubar';
// import { BasicDemoMenuBar } from './BasicMenuBar';
// import { IAppState } from '../../../store/reducers';
// import { setDrawerCurrentState } from '../../../store/actions';

// // import { ITest, MaskUnmask } from "@websential/cosmic-v20";

// export interface IEnhancedAppBar extends ITest {
//   /**
//    * Icon to be displayed before the title
//    */
//   titleIcon?: React.ReactNode;
//   /**
//    * Title of the Appbar
//    */
//   title?: string;
//   /**
//    * An items toolbar to be added at right of Appbar; it may contain the user profile or notifications components
//    */
//   mask?: React.ReactNode;

//   toolbar?: React.ReactNode;
//   /**
//    * Use to set the width of appBar
//    */
//   drawerWidth: string;
//   /**
//    * Content to be display in toolbar (should be a react component)
//    */
//   toolbarMenuContent: React.ReactNode;

//   testId: string;
// }

// const StyledIcon = styled('div')(({ theme }) => ({
//   margin: theme.spacing(2),
//   display: "flex",
//   color: grey[500],
// }));

// interface StyledAppBarProps {
//   width: string;
//   "data-testid": string;
//   children?: React.ReactNode;
// }

// const StyledAppBar = styled((props:StyledAppBarProps) => {

//   return <AppBar {...props} />
// })(
//   ({ theme, width }: any) => `
//   background-color: #ffffff;
//   padding:0;
//   color: ${grey[700]};
//   width: ${width};
//   // width: ${`calc(100% - 240px)`};
//   marginLeft: 240px;
//   z-index:3;
//   box-shadow:0px 2px 4px -1px rgba(0,0,0,0),0px 4px 5px 0px rgba(0,0,0,0.05),0px 1px 10px 0px rgba(0,0,0,0);
//   :hover {
//     color: ${theme.palette.primary.main, 0.2};
//   }
// `,
// );

// export const EnhancedAppBar: FC<IEnhancedAppBar> = ({
//   titleIcon,
//   title,
//   mask,
//   toolbar,
//   testId,
//   drawerWidth,
//   toolbarMenuContent
// }: IEnhancedAppBar) => {
//   const theme = useTheme();
//   const dispatch = useDispatch()
//   const navigate = useNavigate();
//   const drawerAction = useSelector((state:IAppState) => state.drawerAction.open)
//   const [buttonState, setButtonState] = useState(drawerAction);
//   const onToggleButtonClickHandler = (e:any) => {
//     // Toggle the state between true and false
//     setButtonState((prevButtonState:any) => !prevButtonState);

//     // alert(buttonState)

//   }

//   useEffect(()=>{
//     dispatch(setDrawerCurrentState({open:buttonState}));

//   },[buttonState])

//   const items = [
//     // {
//     //     label: 'Home',
//     //     items: [
//     //         {
//     //             label: 'Dashboard',
//     //             // url: "/#/clients/dashboard",
//     //             // command: () => {
//     //             //   history.push('/installation');
//     //             // }
//     //             // Use Link instead of router.push
//     //             // content: <Link to="/clients/dashboard">Dashboard</Link>,
//     //             // command:onHomeClicked,
//     //             command: () => {
//     //               // router.push('/installation');
//     //               alert("fffff")
//     //               // navigate("/clients/dashboard")
//     //           },
//     //         },
//     //         {
//     //             label: 'Client List',
//     //             // url: '/#/accountants/clients'
//     //         },
//     //         {
//     //             label: 'Super User',
//     //             // url: '/#/accountants'
//     //         },
//     //         {
//     //             label: 'Global Search',
//     //             // url: '/#/global-search'
//     //         },
//     //     ]
//     // },
//     // {
//     //   label: "Report",

//     //   items: [
//     //     {
//     //       label: "Employees",
//     //       command: () => {
//     //         // navigate("/reports/employees");
//     //       },
//     //     },
//     //     {
//     //       label: "Vendors",
//     //       command: () => {
//     //         // navigate("/reports/vendors");
//     //       },
//     //     },
//     //   ]
//     //   },
//       {
//         label: 'Home',
//         icon: 'pi pi-home'
//     },
//     {
//         label: 'Features',
//         icon: 'pi pi-star'
//     },
//     {
//         label: 'Projects',
//         icon: 'pi pi-search',
//         items: [
//             {
//                 label: 'Components',
//                 icon: 'pi pi-bolt'
//             },
//             {
//                 label: 'Blocks',
//                 icon: 'pi pi-server'
//             },
//             {
//                 label: 'UI Kit',
//                 icon: 'pi pi-pencil'
//             },
//             {
//                 label: 'Templates',
//                 icon: 'pi pi-palette',
//                 items: [
//                     {
//                         label: 'Apollo',
//                         icon: 'pi pi-palette'
//                     },
//                     {
//                         label: 'Ultima',
//                         icon: 'pi pi-palette'
//                     }
//                 ]
//             }
//         ]
//     },
//     {
//         label: 'Contact',
//         icon: 'pi pi-envelope'
//     }

// ];

//   return (
//     <StyledAppBar data-testid={testId} width={drawerWidth}>
//       <Toolbar sx={{padding:"0 15px !important"}}>
//       <IconButton aria-label="toggle" sx={{borderRadius:"5px"}} onClick={onToggleButtonClickHandler}>
//             <DehazeIcon sx={{margin:0}}/>
//       </IconButton>
//         <StyledIcon data-testid={testId + "-icon"}>
//           {titleIcon}
//         </StyledIcon>
//         <Typography
//           variant="h5"
//           noWrap
//           sx={{
//             // marginLeft: theme.spacing(2),
//             display: "flex",
//           }}
//           data-testid={testId + "-title"}
//         >
//           {title}
//         </Typography>

//         <div style={{ flexGrow: 20 }} />
//         {/* <BasicDemoMenuBar /> */}
//         {toolbarMenuContent}

//           {mask}
//         <div style={{ flexGrow: 1 }} />
//         <div data-testid={testId + "-toolbar"}>{toolbar}</div>
//       </Toolbar>
//     </StyledAppBar>
//   );
// };

// use drawer with multiple steps

import "./EnhancedAppBarStyle.css";

import { Box, IconButton, useMediaQuery } from "@mui/material";
import { EnhancedDropDown, ITest } from "@websential/cosmic-v20";
import React, { FC, useEffect, useMemo, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";

import AppBar from "@mui/material/AppBar";
import { BasicDemoMenuBar } from "./BasicMenuBar";
import DehazeIcon from "@mui/icons-material/Dehaze";
import { EnhancedButtonPrimeReact } from "../../../components/EnhancedButtonPrimeReact";
import { IAppState } from "../../../store/reducers";
import MenuIcon from "@mui/icons-material/Menu";
import { MenuItem } from "../../../components/RoleBasedLeftMenu/MultiLevelDrawer";
import { Menubar } from "primereact/menubar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";
import { setDrawerCurrentState } from "../../../store/actions";
import { useNavigate } from "react-router-dom";

// import { setDrawerCurrentState } from 'store/actions/drawerActions';









// import { ITest, MaskUnmask } from "@websential/cosmic-v20";

export interface IEnhancedAppBar extends ITest {
	/**
	 * Icon to be displayed before the title
	 */
	titleIcon?: React.ReactNode;
	/**
	 * Title of the Appbar
	 */
	title?: string;
	/**
	 * An items toolbar to be added at right of Appbar; it may contain the user profile or notifications components
	 */
	mask?: React.ReactNode;

	toolbar?: React.ReactNode;
	/**
	 * Use to set the width of appBar
	 */
	drawerWidth: string;
	/**
	 * Content to be display in toolbar (should be a react component)
	 */
	toolbarMenuContent: React.ReactNode;

	testId: string;

	appBarHeader: React.ReactNode;

	toggleDrawer: (value: boolean) => void
}

const StyledIcon = styled("div")(({ theme }) => ({
	margin: theme.spacing(2),
	display: "flex",
	color: grey[500],
}));

interface StyledAppBarProps {
	width: string;
	"data-testid": string;
	children?: React.ReactNode;
}

const StyledAppBar = styled((props: StyledAppBarProps) => {

	return <AppBar {...props} />;
})(
	({ theme, width }: any) => `
  // background-color: #ffffff;
//   background-color: #000000;
  background-color: var(--sp-primary-dark);  // dark-blue 
//   background-color: #002419;  // dark-green
  padding:0;
  // color: ${grey[700]};
  color: #ffffff;
  width: ${width};
  // width: ${`calc(100% - 240px)`};
  marginLeft: 240px;
  z-index:3!important;
  // box-shadow:0px 2px 4px -1px rgba(0,0,0,0),0px 4px 5px 0px rgba(0,0,0,0.05),0px 1px 10px 0px rgba(0,0,0,0);
  box-shadow:none;
  :hover {
    color: ${(theme.palette.primary.main, 0.2)};
  }
`
);
const getInitials = (label: string): string => {
	const words = label.trim().split(/\s+/).filter(Boolean);
	const initials = words
		.slice(0, 2)
		.map((word) => word[0]?.toUpperCase() ?? "")
		.join("");
	return initials || "?";
};
const buildClientDropdownItems = (clients: any[]) =>
	clients.map((client) => ({
		value: client.value,
		label: (
			<span className="cd-client-option">
				<span className="cd-client-option__avatar">{getInitials(client.label)}</span>
				<span className="cd-client-option__text">
					<span className="cd-client-option__name">{client.label}</span>
					{client.craBusinessNumber && <span className="cd-client-option__cra">{client.craBusinessNumber}</span>}
				</span>
			</span>
		),
	}));

export const EnhancedAppBar: FC<IEnhancedAppBar> = ({
	titleIcon,
	title,
	mask,
	toolbar,
	testId,
	drawerWidth,
	toolbarMenuContent,
	appBarHeader,
	toggleDrawer
}: IEnhancedAppBar) => {
	// RESPONSIVE
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const isMediumScreen01 = useMediaQuery(theme.breakpoints.between(900, 1200));
	const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen || isMediumScreen01;
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const drawerAction = useSelector(
		(state: IAppState) => state.drawerAction.open
	);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenuOptions.menu
	);
	// console.log('drawerMenuOptionsdrawerMenuOptions', drawerMenuOptions)
	const clientId = useSelector((state: IAppState) => state.client.id);
	const [buttonState, setButtonState] = useState(drawerAction);
	const onToggleButtonClickHandler = (e: any) => {
		// Toggle the state between true and false
		setButtonState((prevButtonState: any) => !prevButtonState);

		// alert(buttonState)

	};

	useEffect(() => {
		dispatch(setDrawerCurrentState({ open: buttonState }));
	}, [buttonState]);

	const items = [
		// {
		//     label: 'Home',
		//     items: [
		//         {
		//             label: 'Dashboard',
		//             // url: "/#/clients/dashboard",
		//             // command: () => {
		//             //   history.push('/installation');
		//             // }
		//             // Use Link instead of router.push
		//             // content: <Link to="/clients/dashboard">Dashboard</Link>,
		//             // command:onHomeClicked,
		//             command: () => {
		//               // router.push('/installation');
		//               alert("fffff")
		//               // navigate("/clients/dashboard")
		//           },
		//         },
		//         {
		//             label: 'Client List',
		//             // url: '/#/accountants/clients'
		//         },
		//         {
		//             label: 'Super User',
		//             // url: '/#/accountants'
		//         },
		//         {
		//             label: 'Global Search',
		//             // url: '/#/global-search'
		//         },
		//     ]
		// },
		// {
		//   label: "Report",

		//   items: [
		//     {
		//       label: "Employees",
		//       command: () => {
		//         // navigate("/reports/employees");
		//       },
		//     },
		//     {
		//       label: "Vendors",
		//       command: () => {
		//         // navigate("/reports/vendors");
		//       },
		//     },
		//   ]
		//   },
		{
			label: "Home",
			icon: "pi pi-home",
		},
		{
			label: "Features",
			icon: "pi pi-star",
		},
		{
			label: "Projects",
			icon: "pi pi-search",
			items: [
				{
					label: "Components",
					icon: "pi pi-bolt",
				},
				{
					label: "Blocks",
					icon: "pi pi-server",
				},
				{
					label: "UI Kit",
					icon: "pi pi-pencil",
				},
				{
					label: "Templates",
					icon: "pi pi-palette",
					items: [
						{
							label: "Apollo",
							icon: "pi pi-palette",
						},
						{
							label: "Ultima",
							icon: "pi pi-palette",
						},
					],
				},
			],
		},
		{
			label: "Contact",
			icon: "pi pi-envelope",
		},
	];

	const menuItems = [
		{ label: "Home1", command: () => navigate("/") }, // No submenu
		{ label: "Home", command: () => navigate("/") }, // No submenu
		{ label: "Home", command: () => navigate("/") }, // No submenu
		{ label: "Home", command: () => navigate("/") }, // No submenu
	];

	const leftSpacingAccordingToDrawerTotalWidth = useSelector(
		(state: IAppState) => state.drawerAction.width
	);
	const subMenuItemsStore = useSelector(
		(state: IAppState) => state.drawerAction.subMenuItemsStore
	);
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const subMenuSelectedItem = useSelector(
		(state: IAppState) => state.drawerAction.subMenuSelectedItem
	);

	const [selectedSubItem, setSelectedSubItem] = useState<string | null>(
		localStorage.getItem("selectedSubItem") || null
	);
	const [subMenuItems, setSubMenuItems] = useState<MenuItem[] | null>(null);
	const [subMenuVisible, setSubMenuVisible] = useState(
		localStorage.getItem("subMenuVisible") === "true"
	);

	useEffect(() => {
		setSelectedSubItem(subMenuSelectedItem);
		setSubMenuItems(subMenuItemsStore);
		setSubMenuVisible(subMenuVisibility);
	}, [subMenuItemsStore, subMenuVisibility, subMenuSelectedItem]);
	const handleSubMenuClick = (subItem: MenuItem) => {
		setSelectedSubItem(subItem.label);
		localStorage.setItem("selectedSubItem", subItem.label);
		subItem.command?.();
	};

	const clients = [
		{
			value: "client-001",
			label: "Sterling Manufacturing Inc.",
			logoUrl: null,
			craBusinessNumber: "CRA · 84521 3392 RP0001",
		},
		{
			value: "client-002",
			label: "Maple Grove Bakery Inc.",
			logoUrl: null,
			craBusinessNumber: "CRA · 84521 3392 RP0001",
		},
		{
			value: "client-003",
			label: "Cascadia Outfitters Inc.",
			logoUrl: null,
			craBusinessNumber: "CRA · 84521 3392 RP0001",
		},
	]
	const years = [
		{
			"label": 2026,
			"value": 2026
		},
		{
			"label": 2025,
			"value": 2025
		},
		{
			"label": 2024,
			"value": 2024
		},
		{
			"label": 2023,
			"value": 2023
		},
		{
			"label": 2022,
			"value": 2022
		},
		{
			"label": 2021,
			"value": 2021
		},
		{
			"label": 2020,
			"value": 2020
		},
		{
			"label": 2008,
			"value": 2008
		},
		{
			"label": 2007,
			"value": 2007
		},
		{
			"label": 2006,
			"value": 2006
		},
		{
			"label": 2005,
			"value": 2005
		},
		{
			"label": 2004,
			"value": 2004
		},
		{
			"label": 2003,
			"value": 2003
		}
	]

	const dropdownItems = useMemo(() => buildClientDropdownItems(clients), [clients]);

	return (
		<StyledAppBar data-testid={testId} width={drawerWidth}>
			<Toolbar
				sx={{
					padding: "0 !important",
					display: "flex",
					flexDirection: "column",
					paddingBottom: drawerMenuOptions?.length === 0 && !mobileTabOrSmallLaptopScreen ? "1rem!important" : ""
				}}
				className="eab-toolbar"
			>
				{/* <IconButton aria-label="toggle" sx={{borderRadius:"5px"}} onClick={onToggleButtonClickHandler}>
            <DehazeIcon sx={{margin:0}}/>
      </IconButton> */}
				<Box sx={{ width: "100%", display: "flex" }} className="eab-top-row">
					{/* Display menu icon for small screens */}
					{drawerMenuOptions?.length ? <IconButton
						color="inherit"
						aria-label="open drawer"
						onClick={() => toggleDrawer(true)}
						sx={{ display: { lg: "none" }, color: "#fff", ml: 1.25 }}
					>
						<MenuIcon />
					</IconButton> : <></>}
					<Typography
						style={{
							fontSize: "1.5rem",
							// display: "flex",
							// height: "60px",
							height: "59px",
							justifyContent: "center",
							alignItems: "center",
							// color:"#000",
							color: "#ffffff",
							fontWeight: "bold",
							paddingLeft: "15px",
						}}
						sx={{ display: { lg: "flex", xl: "flex", md: "flex", sm: "flex", xs: "none" } }}
						className="eab-context top-menu-bar-drop-down"
					>
						{/* {appBarHeader} */}
						{clientId ? <><div className="top-menu-bar-client-drop-down">
							<EnhancedDropDown
								selectName="client"
								testId="client-select-list"
								items={dropdownItems}
								selectedItem={"client-001"}
								onSelectionChangeHandler={() => alert("Coming Soon...")}
								isSearchable={false}
							/>
						</div>
							<div className="top-menu-bar-year-drop-down">
								<EnhancedDropDown
									selectName="year"
									testId="client-select-list"
									items={years}
									selectedItem={2026}
									onSelectionChangeHandler={() => alert("Coming Soon...")}
									isSearchable={false}
								/>
							</div>
						</> : appBarHeader}
					</Typography>

					<div style={{ flexGrow: 1 }} />
					<div className="eab-user" data-testid={testId + "-toolbar"}>{toolbar}</div>

					<Box
						sx={{ paddingRight: "10px", alignItems: "center", display: { lg: "none", xl: "none", md: "flex", sm: "flex", xs: "none" } }}
					>

						<span>{mask}</span>
						{clientId && <i
							className={"pi pi-cog"}
							onClick={() => navigate("/settings/general/setup")}
							style={{ cursor: "pointer", marginLeft: "1rem" }}
						/>}
						<i
							className={"pi pi-sign-out"}
							onClick={() => navigate("/logout")}
							style={{ cursor: "pointer", marginLeft: "1rem" }}
						/>
					</Box>
					<Box
						sx={{ paddingTop: "3px", alignItems: "center", paddingRight: "10px", display: { lg: "none", xl: "none", md: "none", sm: "none", xs: "flex" } }}
					>
						<span style={{ marginLeft: "0.5rem", marginBottom: "7px" }}>{mask}</span>
						{clientId && <i
							className={"pi pi-cog"}
							onClick={() => navigate("/settings/general/setup")}
							style={{ cursor: "pointer", marginLeft: "1rem", marginBottom: "7px" }}
						/>}
					</Box>
				</Box>

				{/* small screen tk  */}
				{/* <Box sx={{ display: { xs: "none", md"flex" }, width: "100%" }}> */}


				{/* laptop screen tk  */}
				<Box sx={{ display: { xs: "none", md: "none", lg: "flex" }, width: "100%" }}>
					{/* <img
          src={`https://www.simplepay.ca/canada_payroll/index/img/simplepay_logo.png`}
          alt="Simple Pay Logo"
          style={{width:"150px",
            // when we have two divs inside toolbar
            height:"25px",
            marginTop:"16px"
          }}
        /> */}
					{/* <StyledIcon data-testid={testId + "-icon"}>
          {titleIcon}
        </StyledIcon> */}
					{/* <Typography
          variant="h5"
          noWrap
          sx={{
            // marginLeft: theme.spacing(2),
            display: "flex",
          }}
          data-testid={testId + "-title"}
        >
          {title}
        </Typography> */}

					{/* <div style={{ flexGrow: 20 }} /> */}
					{/* <BasicDemoMenuBar /> */}
					{toolbarMenuContent}

					<div style={{ flexGrow: 1 }} />
					<div className="side-icons-bar">
						{mask}
						<Box
							sx={{ display: "flex", alignItems: "center" }}
						>
							{clientId && <i
								className={"pi pi-cog"}
								onClick={() => navigate("/settings/general/setup")}
								style={{ cursor: "pointer" }}
							/>}
						</Box>
						<Box
							sx={{ paddingRight: "10px", display: "flex", alignItems: "center" }}
						>
							<i
								className={"pi pi-sign-out"}
								onClick={() => navigate("/logout")}
								style={{ cursor: "pointer" }}
							/>
						</Box>
					</div>
					{/* <div data-testid={testId + "-toolbar"}>{toolbar}</div> */}
				</Box>
			</Toolbar>

			{/* {subMenuVisible && subMenuItems && (
				<div
					style={{
						left: `${leftSpacingAccordingToDrawerTotalWidth}px`,
						position: "fixed",
						width: "100%",
						top: "112px",
					}}
				>
					<Box className="secondary-drawer">
						<ul
							className="p-0 m-0"
							style={{ display: "flex", listStyleType: "none" }}
						>
							{subMenuItems?.map((subItem: any, index: any) => (
								<li
									key={index}
									onClick={() => handleSubMenuClick(subItem)}
									className={`cursor-pointer p-3 rounded ${
										selectedSubItem === subItem.label
											? "selected-item-bg-color-second-nav text-white"
											: "hover:bg-gray-300"
									}`}
								>
									{subItem.label}
								</li>
							))}
						</ul>
					</Box>
				</div>
			)} */}
		</StyledAppBar>
	);
};
